import { clearMultiAddAnchor } from '../../../../state/internal/actions';
import { defineTransaction } from '../../../common/transactions';
import { CLEAR_MULTI_ADD_ANCHOR } from './action';

export default defineTransaction(CLEAR_MULTI_ADD_ANCHOR, () => clearMultiAddAnchor());
